import { Injectable } from '@angular/core';
import { TrainParameters } from '@dossier/models';
import { hasValue } from '@util';
import * as R from 'ramda';

const cleanUpAgencyParameter = param => R.evolve({
  typeInfo: R.pick(['type']) as any
},
R.pick(['id', 'dossierLevel', 'typeInfo'], param) as any
);

const cleanUpImParameter = (imParameter) => R.evolve({
  agencyParameter: cleanUpAgencyParameter,
  children: R.map(cleanUpImParameter)
},
imParameter
);

@Injectable()
export class TrainParametersService {

  cleanUpAllParameters = R.compose(
    (trainParameters) => this.cleanUpTrainParameters(trainParameters),
    (trainParameters) => this.cleanUpImParameters(trainParameters)
  );

  cleanUpTrainParameters(trainParameters: TrainParameters) {
    return R.mergeRight(trainParameters, {
      exceptionalGaugingIdents: R.filter(hasValue, trainParameters.exceptionalGaugingIdents)
    });
  }

  cleanUpImParameters(trainParameters: TrainParameters) {
    return trainParameters.imParameters ? R.mergeRight(trainParameters, {
      imParameters: R.map(cleanUpImParameter, trainParameters.imParameters)
    }) : trainParameters;
  }
}
